import { render, staticRenderFns } from "./info-screening-insurer.vue?vue&type=template&id=2ffc8f74&scoped=true&"
import script from "./info-screening-insurer.vue?vue&type=script&lang=js&"
export * from "./info-screening-insurer.vue?vue&type=script&lang=js&"
import style0 from "./info-screening-insurer.vue?vue&type=style&index=0&id=2ffc8f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffc8f74",
  null
  
)

export default component.exports